import { render, staticRenderFns } from "./PrivateTag.vue?vue&type=template&id=23bf716c&"
import script from "./PrivateTag.vue?vue&type=script&lang=js&"
export * from "./PrivateTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports